{
  "name": "mp-fe-project",
  "version": "0.0.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:test": "ng build --configuration test",
    "build:preprod": "ng build --configuration preprod",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.2",
    "@angular/cdk": "^21.2.1",
    "@angular/common": "^21.2.2",
    "@angular/compiler": "^21.2.2",
    "@angular/core": "^21.2.2",
    "@angular/forms": "^21.2.2",
    "@angular/material": "^21.2.1",
    "@angular/platform-browser": "^21.2.2",
    "@angular/platform-browser-dynamic": "^21.2.2",
    "@angular/router": "^21.2.2",
    "@mic-ac/ui-kit": "^0.6.32",
    "angular-oauth2-oidc": "^17.0.2",
    "leaflet": "^1.9.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.1",
    "@angular/cli": "^21.2.1",
    "@angular/compiler-cli": "^21.2.2",
    "@tailwindcss/postcss": "^4.2.1",
    "@types/jasmine": "~5.1.0",
    "@types/leaflet": "^1.9.21",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.8",
    "tailwindcss": "^4.2.1",
    "typescript": "~5.9.3"
  }
}
